import React from "react";
import PropTypes from "prop-types";
import useCatalogProductSlots from "../../core/use-catalog-product-slots.jsx";
import styles from "./CartDrawerHorizontalProductLayout.module.css";

/** Horizontal row for static cart drawer upsell — image | details | CTA. */
export default function CartDrawerHorizontalProductLayout(props) {
  const {
    productIndex,
    productData,
    showProductCheckbox = false,
    isFbtBundleCheckbox = false,
    isProductCheckboxSelected,
    onProductCheckboxChange,
    isProductCheckboxDisabled,
  } = props;
  const isSoldOut = productData?.weupsellOutOfStock === true;
  const soldOutLabel =
    productData?.weupsellSoldOutMessage || "Sold out";

  const {
    imageBlock,
    metaBlock,
    controlsBlock,
    ctaBlock,
    cardShellStyle,
    imageColStyle,
  } = useCatalogProductSlots({
    ...props,
    isHorizontal: true,
    separateCtaColumn: !showProductCheckbox,
    layoutProfile: showProductCheckbox ? "cart-drawer-checkbox-stack" : "cart-drawer-horizontal",
    hideProductButton: showProductCheckbox || props.hideProductButton,
  });

  const isChecked =
    typeof isProductCheckboxSelected === "function"
      ? isProductCheckboxSelected(productIndex)
      : false;

  const isDisabled =
    isSoldOut ||
    (typeof isProductCheckboxDisabled === "function"
      ? isProductCheckboxDisabled(productIndex)
      : false);

  const handleCheckboxChange = (event) => {
    if (isDisabled) return;
    event.stopPropagation();
    onProductCheckboxChange?.(productIndex, event.target.checked);
  };

  return (
    <article
      className={`${styles.root}${showProductCheckbox ? ` ${styles.checkboxBundle}` : ""}${
        isFbtBundleCheckbox ? ` ${styles.fbtBundleCheckbox}` : ""
      }${isSoldOut ? ` ${styles.soldOut}` : ""}`}
      style={cardShellStyle}
      data-product-index={productIndex}
      data-shell-layout={
        showProductCheckbox ? "cart-drawer-checkbox-stack-v1" : "cart-drawer-horizontal-v1"
      }
      data-checkbox-bundle={showProductCheckbox ? "true" : undefined}
      data-fbt-bundle={isFbtBundleCheckbox ? "true" : undefined}
      data-sold-out={isSoldOut ? "true" : undefined}
      aria-disabled={isSoldOut || undefined}
    >
      <div className={styles.mainRow}>
        {showProductCheckbox ? (
          <div className={styles.checkboxCol}>
            <input
              type="checkbox"
              className={styles.productCheckbox}
              checked={isChecked}
              disabled={isDisabled}
              onChange={handleCheckboxChange}
              aria-label="Add this product with main item"
            />
          </div>
        ) : null}
        <div className={styles.imageCol} style={imageColStyle}>
          {imageBlock}
          {isSoldOut ? (
            <span className={styles.soldOutBadge}>{soldOutLabel}</span>
          ) : null}
        </div>
        <div className={styles.metaCol}>
          {metaBlock}
          {controlsBlock}
        </div>
        {ctaBlock && !isSoldOut ? (
          <div className={styles.ctaCol}>{ctaBlock}</div>
        ) : isSoldOut ? (
          <div className={styles.ctaCol}>
            <span className={styles.soldOutCta}>{soldOutLabel}</span>
          </div>
        ) : null}
      </div>
    </article>
  );
}

CartDrawerHorizontalProductLayout.propTypes = {
  section: PropTypes.object,
  productData: PropTypes.object,
  productIndex: PropTypes.number,
  popupData: PropTypes.object,
  isMobile: PropTypes.bool,
  showProductCheckbox: PropTypes.bool,
  isFbtBundleCheckbox: PropTypes.bool,
  isProductCheckboxSelected: PropTypes.func,
  onProductCheckboxChange: PropTypes.func,
  isProductCheckboxDisabled: PropTypes.func,
};
